import styled from 'styled-components';
import { PhoneIcon } from '@/components/UI/Icons/Icons';

export const Box = styled.div<{ $loading?: boolean }>`
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  min-width: 0;
  ${({ $loading }) => ($loading ? 'min-height: 400px;' : '')}

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 0;
    gap: 25px;
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const SkeletonCard = styled.div`
  height: 200px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  background: ${({ theme }) => theme.palette.secondary.background};
`;

export const DesktopPhonesBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;
`;

export const DesktopPhonesPopup = styled.div`
  position: fixed;
  z-index: 1000;
  min-width: 240px;
  padding: 12px 0;
  border-radius: 14px 14px 0 0;
  background: #fff;
  box-shadow: 0 -2px 12px rgba(18, 20, 25, 0.12),
    0 4px 16px rgba(18, 20, 25, 0.12);
`;

export const DesktopPhonesLink = styled.a`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 15px;
  font-weight: 400;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.1s ease;

  &:hover {
    background: ${({ theme }) => theme.palette.secondary.background};
  }
`;

export const DesktopPhonesIconWrap = styled.span`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DesktopPhonesPhoneIcon = styled(PhoneIcon).attrs(({ theme }) => ({
  fill: theme.palette?.system?.green ?? '#00a651',
}))``;
